import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Smile Design Secret',
    description:
        'Evidence-based dental knowledge across cosmetic dentistry, dental health, and general dentistry, with clear, trustworthy guides grounded in current dental research.',
    url: 'https://smiledesignsecret.com',
    domain: 'smiledesignsecret.com',
    tagline: 'Dental knowledge, decoded.'
}
